var ShowCaseSelectContent = function ShowCaseSelectContent(data) {
  var _data$showcase;
  var text = "".concat((data == null ? void 0 : data.type) || null, ":").concat((data == null ? void 0 : (_data$showcase = data.showcase) == null ? void 0 : _data$showcase.title) || null, ":slot-").concat((data == null ? void 0 : data.listPosition) || null, ":descubra-outras-ofertas-aqui");
  var formattedText = text ? text.trim().toLowerCase().replace(/\s+/g, '-') : null;
  return {
    content_id: formattedText,
    content_type: "".concat((data == null ? void 0 : data.pageName) || null, ":mundo-magalu:vitrine"),
    event: 'select_content'
  };
};
export default ShowCaseSelectContent;